// https://www.freakyjolly.com/react-charts-examples/

import React from "react";
import { ResponsiveContainer, LineChart, AreaChart, Area, YAxis, XAxis, CartesianGrid, Tooltip, Legend, Line } from 'recharts';
import { useAppSelector, useAppDispatch } from 'src/hooks';

import _ from "lodash";

import { variable_names, variable_units } from 'src/constants'

// TODO - move to a "utilities" file
// couldn't get these to work in Typescript:
// https://stackoverflow.com/questions/3730510/javascript-sort-array-and-return-an-array-of-indices-that-indicates-the-positio
// so, obtained the function below by asking ChatGPT:
// "Write a Javascript function that takes an array and returns a permutation which rearranges its first argument
// into ascending or descending order, breaking ties by further arguments"
// where the wording is based on the description of this function
// https://www.rdocumentation.org/packages/base/versions/3.6.2/topics/order
function sortWithTies(arr: Array<number>, direction = 'asc') {
    const permutation = Array.from(arr.keys());
    permutation.sort((i, j) => {
        const cmp = arr[i] - arr[j];
        if (cmp !== 0) {
            return direction === 'asc' ? cmp : -cmp;
        }
        for (let k = 1; k < arr.length; k++) {
            const argCmp = arr[i + k] - arr[j + k];
            if (argCmp !== 0) {
                return direction === 'asc' ? argCmp : -argCmp;
            }
        }
        return i - j;
    });
    return permutation;
}

// https://bobbyhadz.com/blog/react-property-does-not-exist-on-type-readonly#:~:text=The%20React.,state%20objects%20of%20the%20class.
export default function Line_chart() {

    // maybe just select pointData all at once? (TODO - consider)
    const ids = useAppSelector((state: any) => state.basic.pointData.ids);
    const site_name = useAppSelector((state: any) => state.basic.pointData.site_name);
    const values = useAppSelector((state: any) => state.basic.pointData.values);
    const variable = useAppSelector((state: any) => state.basic.map.variable);
    const scenario = useAppSelector((state: any) => state.basic.map.scenario);

    // Debug logging
    console.log('Line_chart Debug:', {
        ids: ids,
        site_name: site_name,
        values: values,
        variable: variable,
        scenario: scenario,
        values_length: values?.length,
        variable_empty: variable === ""
    });

    // TODO - maybe move to constants.tsx (avoid duplication)
    const palette = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf'];
    const ord = sortWithTies(ids); // order table rows by id variable

    //console.log(values[0]["heat_ssp126_2020"]);
    // https://stackoverflow.com/questions/3010840/loop-through-an-array-in-javascript
    const years = _.range(2020, 2105, 5);
    var data: any = [];
    var line_list: any = []; // https://github.com/recharts/recharts/issues/421
    if (values.length > 0 && variable != "" && scenario != "") {
        for (let i = 0; i < years.length; i++) {
            let year_dict: any = { 'year': years[i] }
            for (let j = 0; j < values.length; j++) {
                // Use the selected scenario instead of hardcoded ssp585
                const dataKey = `${variable}_${scenario}_${years[i]}`;
                year_dict[site_name[j]] = values[j][dataKey];
            }
            data.push(year_dict);
        }
        for (let j = 0; j < values.length; j++) {
            let ind = ord[j]; // want to match table/palette order
            line_list.push(<Line key={ind} type="monotone" dataKey={site_name[ind]} stroke={palette[ids[ind]]} />)
        }
    }

    console.log('Line_chart rendering with data:', data);
    console.log('Line_chart line_list:', line_list);

    if (!values || values.length === 0) {
        return <div>No data available for line chart</div>;
    }

    if (!variable || variable === "") {
        return <div>No variable and scenario selected for line chart</div>;
    }

    return (
        <ResponsiveContainer width="100%" aspect={2}>
            <LineChart width={730} height={250} data={data}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                {/* https://recharts.org/en-US/api/Label */}
                <XAxis dataKey="year" label={{ value: "Year", offset: -10, position: "insideBottom" }} />
                {/* https://github.com/recharts/recharts/issues/2105 */}
                <YAxis label={{ value: variable_units[variable as keyof typeof variable_units], angle: -90, position: "insideLeft", style: { textAnchor: 'middle' } }} />
                <Tooltip />
                <Legend wrapperStyle={{ bottom: -10 }} />
                {line_list}
            </LineChart>
        </ResponsiveContainer>
    )
};
